import Const from 'constants';
import {Storage} from 'storages/storage';
import {getLpService} from 'services/sports/factory';

let OptimizationConfig = {
    createOptimizationConfig() {
        return (dispatch, getState) => {
            const config = getLpService(getState().sportConfig, {store: new Storage()}).exec(
                'getInitialOptimizationConfig',
                null,
                {},
            );

            dispatch(this.setOptimizationConfig(config));
        };
    },

    setOptimizationConfig(config) {
        return {
            type: Const.OPTIMIZATION_SET_CONFIG,
            data: config,
        };
    },
    setRunSettings(key, settings) {
        return {
            type: Const.SAVE_RUN_SETTINGS,
            key,
            settings,
        };
    },
};

export default OptimizationConfig;
